import { createAction } from 'typesafe-actions';

export const FOLD = 'foldNav/FOLD' as const;
export const NAV = 'foldNav/NAV' as const;

export const setFoldNav = createAction(FOLD)<boolean>();
